﻿import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import { config } from '../../../assets/config';

@Injectable()
export class SearchLexiboxService {
    constructor(private http: HttpClient) {}

    getByName(patientId: string, search: string) {
        const params = new HttpParams().set('filter', '{"where": {"name": {"like": "' + search + '","options": "i" } } }');
        return this.http.get(`${config.apiUrl}/patients/` + patientId + '/lexibox', {params});
    }
}
